<template>
  <div class="key-page">
    <div class="ipt-top">
      <div class="key-top">
        <el-input placeholder="请输入项目名称" v-model="word">
          <el-button slot="append" color="primary" @click="serach">查询</el-button>
        </el-input>
      </div>
    </div>

    <el-table v-loading="listLoading" stripe style="width:100%" border :data="tableData">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="name" label="项目名称"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="goshen(scope.row,'keyshen')">配置审核关键字</el-button>
          <el-button type="text" size="small" @click="goshen(scope.row,'keywu')">配置物流关键字</el-button>
          <el-button type="text" size="small" @click="goshen(scope.row,'keyte')">特殊材料关键字</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { projectpage } from "@/api/Materialkey";
export default {
  data() {
    return {
      tableData: [],
      word: null,
      listLoading: false
    };
  },
  created() {
    if (this.$route.query.hasOwnProperty("word")) {
      this.word = this.$route.query.word;
      this.initData(this.word);
    } else {
      this.initData(null);
    }
  },
  methods: {
    initData(word) {
      this.listLoading = true;
      const info = {
        pageSize: 1000,
        pageIndex: 1,
        name: word
      };
      projectpage(info).then(res => {
        this.listLoading = false;
        this.tableData = res.data.records;
      });
    },
    serach() {
      if (this.word) {
        this.initData(this.word.trim());
        this.$router.replace({ query: { word: this.word.trim() } });
      } else {
        this.initData(null);
        this.$router.replace({ query: null });
      }
    },
    goshen(row, key) {
      this.$router.push({ name: key, query: { id: row.id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.key-page {
  .ipt-top {
    display: flex;
    justify-content: flex-end;
    .key-top {
      margin-bottom: 20px;
      width: 40%;
      max-width: 300px;
      min-width: 200px;
    }
  }
}
</style>
<style lang="scss">
.key-page {
  .ipt-top {
    .el-input-group__append {
      background-color: rgb(24, 144, 255);
      color: #fff;
    }
  }
}
</style>